// sdal-project-frontend/src/services/auth.js

import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Token içeriğini okumak için

// NOT: Backend'iniz 8000 portunda çalışıyor
const API_URL = 'https://sdal-project-backend.onrender.com/api';

const authService = {
    // 1. KULLANICI GİRİŞ İŞLEMİ (TOKEN ALMA)
    login: async (email, password) => {
        const response = await axios.post(`${API_URL}/token/`, { 
            email, 
            password 
        });
        
        if (response.data.access) {
            localStorage.setItem('accessToken', response.data.access);
            localStorage.setItem('refreshToken', response.data.refresh);
            
            const decodedUser = jwtDecode(response.data.access);
             localStorage.setItem('userId', decodedUser.user_id);
            // Hata Düzeltmesi: decodedUser doğru şekilde kullanılıyor.
            // Token'a eklenen 'is_staff' bilgisini kontrol edip kaydediyoruz.
            localStorage.setItem('isAdmin', decodedUser.is_staff ? 'true' : 'false'); 
            
            localStorage.setItem('userEmail', decodedUser.email);
        }
        return response.data;
    },
    
    // 2. YÖNETİCİ KONTROLÜ
    isUserAdmin: () => {
        // LocalStorage'dan isAdmin değerini çekiyoruz.
        return localStorage.getItem('isAdmin') === 'true';
    },

    // 3. TOKEN'I İSTEK BAŞLIĞINA EKLEME (Api.js'te kullanmak için)
    getAuthHeader: () => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            // Authorization: Bearer <token> formatı JWT standardıdır
            return { Authorization: `Bearer ${token}` };
        } else {
            return {};
        }
    },

    // 4. KULLANICI ÇIKIŞ İŞLEMİ
    logout: () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('isAdmin'); // Admin bilgisini de siliyoruz
    },
    
    // 5. YENİ KULLANICI KAYIT İŞLEMİ
    register: async (userData) => {
        const response = await axios.post(`${API_URL}/users/`, userData); 
        return response.data;
    }

    
};

export default authService;